import md5 from 'md5'
import Message from '@/packages/message'
import { isEmail, isMobile } from '@/utils/validate'
import homeAxios from '@/views/user/index/homeService'
/**
 *
 * @param {Array} list
 * @param {Function} foo
 * @return {*}
 */
export function find(list, foo) {
  return list.filter(foo)[0]
}
/**
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy(obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

export function copyObject(a, b) {
  Object.keys(b).forEach(key => {
    if (!a[key]) {
      a[key] = b[key]
    }
  })
  return a
}

/**
 * forEach for object
 */
export function forEachValue(obj, fn) {
  Object.keys(obj).forEach(key => fn(obj[key], key))
}

export function isObject(obj) {
  return obj !== null && typeof obj === 'object'
}

export function isPromise(val) {
  return val && typeof val.then === 'function'
}

export function assert(condition, msg) {
  if (!condition) throw new Error(`[vuex] ${msg}`)
}
String.prototype.trim = function() {
  return this.replace(/(^\s*)|(\s*$)/g, '')
}

//uuid生成
export function uuid() {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  var uuid = s.join('')
  return uuid
}
//判断对象是否为json格式
export function isJson(obj) {
  var isjson =
    typeof obj == 'object' && Object.prototype.toString.call(obj).toLowerCase() == '[object object]' && !obj.length
  return isjson
}
//密码加密
export function encryption(password) {
  return md5(password)
}
//数据是否存在
export function messageEcho(oldValue, newValue) {
  for (let i = 0; i < oldValue.length; i++) {
    if (oldValue[i].contactName === newValue.contactName && oldValue[i].contactAccount === newValue.contactAccount) {
      return true
    }
  }
  return false
}
//日期格式化
export function formDate(date, format) {
  var args = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3), //quarter
    S: date.getMilliseconds()
  }
  if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var i in args) {
    var n = args[i]
    if (new RegExp('(' + i + ')').test(format))
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? n : ('00' + n).substr(('' + n).length))
  }
  return format
}
//获取token值
export function token() {
  return localStorage.getItem('TOKEN')
}
//浏览器url地址参数处理
export function GetRequest(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg) //search,查询？后面的参数，并匹配正则
  if (r != null && r.length > 1) {
    return unescape(r[2])
  } else {
    return ''
  }
}
//删除url参数设置
export function delParam(paramKey) {
  var url = window.location.href //页面url
  var urlParam = window.location.search.substr(1) //页面参数
  var beforeUrl = url.substr(0, url.indexOf('?')) //页面主地址（参数之前地址）
  var nextUrl = ''

  var arr = new Array()
  if (urlParam != '') {
    var urlParamArr = urlParam.split('&') //将参数按照&符分成数组
    for (var i = 0; i < urlParamArr.length; i++) {
      var paramArr = urlParamArr[i].split('=') //将参数键，值拆开
      //如果键雨要删除的不一致，则加入到参数中
      if (paramArr[0] != paramKey) {
        arr.push(urlParamArr[i])
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = '?' + arr.join('&')
  }
  url = beforeUrl + nextUrl
  if (url == '') {
    return window.location.href
  }
  return url
}

//根据不同印章指定印章宽度和高度
export function signWH(type) {
  let list = { width: 0, height: 0 }
  if (type == 0) {
    list.width = 180
    list.height = 106
  } else if (type == 1) {
    list.width = 180
    list.height = 180
  } else if (type == 2) {
    list.width = 180
    list.height = 40
  } else if (type == 3) {
    list.width = 175
    list.height = 42
  } else if (type == 4) {
    list.width = 200
    list.height = 50
  } else if (type == 5) {
    list.width = 16
    list.height = 16
  } else if (type == 6) {
    list.width = 107
    list.height = 28
  }
  return list
}
export function signFont(list) {
  let widgets = {}
  if (list.type == 0 || list.type == 1 || list.type == 2) {
    widgets = { isRequired: true }
  } else if (list.type == 3) {
    widgets = {
      widgetName: list.widgetName ? list.widgetName : '',
      widgetValue: list.widgetValue ? list.widgetValue : '',
      fontSize: list.fontSize ? list.fontSize : 14,
      align: list.align ? list.align : 'left',
      fontType: list.fontType >= 0 ? list.fontType : 3,
      inputType: list.inputType ? list.inputType : 'input',
      isRequired: list.isRequired
    }
  } else if (list.type == 4) {
    widgets = {
      widgetName: list.widgetName ? list.widgetName : '',
      widgetValue: list.widgetValue ? list.widgetValue : '',
      fontSize: list.fontSize ? list.fontSize : 14,
      align: list.align ? list.align : 'left',
      fontType: list.fontType >= 0 ? list.fontType : 3,
      inputType: list.inputType ? list.inputType : 'textarea',
      isRequired: list.isRequired
    }
  } else if (list.type == 5) {
    widgets = {
      widgetName: list.widgetName ? list.widgetName : '',
      widgetValue: list.widgetValue ? list.widgetValue : true,
      inputType: list.inputType ? list.inputType : 'checkbox',
      isRequired: list.isRequired
    }
  } else {
    widgets = {
      widgetName: list.widgetName ? list.widgetName : '',
      widgetValue: list.widgetValue ? list.widgetValue : '',
      inputType: list.inputType ? list.inputType : 'file',
      isRequired: list.isRequired
    }
  }
  return widgets
}
//生成32位随机数
export function getNum() {
  let chars = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z'
  ]
  var nums = ''
  for (var i = 0; i < 32; i++) {
    var id = parseInt(Math.random() * 61)
    nums += chars[id]
  }
  return nums
}
function setFileType(file) {
  return file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length).toLowerCase()
}
//文件上传
export function fileUpload(e, size) {
  let files = e.target.files || e.dataTransfer.files
  if (!files.length) {
    return false
  }
  for (let i = 0; i < files.length; i++) {
    let fileType = setFileType(files[i])
    if (files[i].name.length > 50) {
      Message.$warning('文件名名称不的大于50个字符')
      return false
    }
    if (
      fileType !== 'docx' &&
      fileType !== 'doc' &&
      fileType !== 'pdf' &&
      fileType !== 'wps' &&
      fileType !== 'xlsx' &&
      fileType !== 'xls'
    ) {
      Message.$warning("请上传'.docx,.pdf,.doc,.wps,.xlsx,.xls'等格式文件!")
      return false
    }
    if (files[i].size / 1024 / 1024 >= size) {
      Message.$warning('文件大小不得超过' + size + 'M')
      return false
    } else if (files[i].size / 1024 === 0) {
      Message.$warning('文件大小不得小于0KB!')
      return false
    }
  }
  return files
}
//上传PDF文件
export function filePdfUpload(e, size) {
  let files = e.target.files || e.dataTransfer.files
  if (!files.length) {
    return false
  }
  let fileType = setFileType(files[0])
  if (fileType !== 'pdf') {
    Message.$warning('请上传PDF格式文件!')
    return false
  }
  if (files[0].size / 1024 / 1024 >= size) {
    Message.$warning('文件大小不得超过' + size + 'M')
    return false
  } else if (files[0].size / 1024 === 0) {
    Message.$warning('文件大小不得小于0KB!')
    return false
  }
  return files[0]
}
//上传图片
export function filImgUpload(e, size) {
  let files = e.target.files || e.dataTransfer.files
  if (!files.length) {
    return false
  }
  let fileType = setFileType(files[0])
  if (fileType !== 'png' && fileType !== 'jpeg' && fileType !== 'jpg' && fileType != 'jpng') {
    Message.$warning("请上传'.png,.jpeg,.jpg,.jpng'等格式文件!")
    return false
  }
  if (files[0].size / 1024 / 1024 >= size) {
    Message.$warning('文件大小不得超过' + size + 'M')
    return false
  } else if (files[0].size / 1024 === 0) {
    Message.$warning('文件大小不得小于0KB!')
    return false
  }
  return files[0]
}
/**
 * 拖拽文件
 * pdf  @getDropPdfUpload
 * 图片 @getDropImgUpload
 */
export function getDropImgUpload(files, size) {
  if (!files) {
    return false
  }
  let fileType = setFileType(files)
  if (fileType !== 'png' && fileType !== 'jpeg' && fileType !== 'jpg' && fileType != 'jpng') {
    Message.$warning("请上传'.png,.jpeg,.jpg,.jpng'等格式文件!")
    return false
  }
  if (files[0].size / 1024 / 1024 >= size) {
    Message.$warning('文件大小不得超过' + size + 'M')
    return false
  } else if (files[0].size / 1024 === 0) {
    Message.$warning('文件大小不得小于0KB!')
    return false
  }
  return files
}
export function getDropPdfUpload(files, size) {
  if (!files) {
    return false
  }
  let fileType = setFileType(files)
  if (fileType !== 'pdf') {
    Message.$warning("请上传'.pdf'等格式文件!")
    return false
  }
  if (files[0].size / 1024 / 1024 >= size) {
    Message.$warning('文件大小不得超过' + size + 'M')
    return false
  } else if (files[0].size / 1024 === 0) {
    Message.$warning('文件大小不得小于0KB!')
    return false
  }
  return files
}
//文件或图片上传
export function fileOrImgUpload(e, size) {
  let files = e.target.files || e.dataTransfer.files
  if (!files.length) {
    return false
  }
  for (let i = 0; i < files.length; i++) {
    let fileType = setFileType(files[i])
    if (files[i].name.length > 50) {
      Message.$warning('文件名名称不的大于50个字符')
      return false
    }
    if (
      fileType !== 'docx' &&
      fileType !== 'doc' &&
      fileType !== 'pdf' &&
      fileType !== 'wps' &&
      fileType !== 'xlsx' &&
      fileType !== 'xls' &&
      fileType !== 'png' &&
      fileType !== 'jpeg' &&
      fileType !== 'jpg' &&
      fileType != 'jpng'
    ) {
      Message.$warning("请上传'.docx,.pdf,.doc,.wps,.xlsx,.xls,png,jpeg,jpg,jpng'等格式文件!")
      return false
    }
    if (files[i].size / 1024 / 1024 >= size) {
      Message.$warning('文件大小不得超过' + size + 'M')
      return false
    } else if (files[i].size / 1024 === 0) {
      Message.$warning('文件大小不得小于0KB!')
      return false
    }
  }
  return files
}
//上传excel文件
export function fileExcelUpload(e, size) {
  let files = e.target.files || e.dataTransfer.files
  if (!files.length) {
    return false
  }
  for (let i = 0; i < files.length; i++) {
    let fileType = setFileType(files[i])
    if (files[i].name.length > 50) {
      Message.$warning('文件名名称不的大于50个字符')
      return false
    }
    if (fileType !== 'xlsx' && fileType !== 'xls') {
      Message.$warning("请上传'.xlsx,.xls'等格式文件!")
      return false
    }
    if (files[i].size / 1024 / 1024 >= size) {
      Message.$warning('文件大小不得超过' + size + 'M')
      return false
    } else if (files[i].size / 1024 === 0) {
      Message.$warning('文件大小不得小于0KB!')
      return false
    }
  }
  return files
}
//下载文件
export function dowandFile(res, fileName) {
  let blob = new Blob([res])
  if ('download' in document.createElement('a')) {
    let a = window.document.createElement('a')
    let url = null
    if ('msSaveOrOpenBlob' in navigator) {
      url = window.navigator.msSaveOrOpenBlob(res, fileName)
    } else {
      url = window.URL.createObjectURL(blob)
    }
    a.addEventListener('click', function(e) {
      a.download = fileName
      a.href = url
    })
    let e = document.createEvent('MouseEvents')
    e.initEvent('click', false, false)
    a.dispatchEvent(e)
    window.URL.revokeObjectURL(url)
  } else {
    navigator.msSaveBlob(blob, fileName)
  }
}
/**
 * 部分隐藏处理
 * str 需要处理的字符串
 * frontLen  保留的前几位
 * endLen  保留的后几位
 * cha  替换的字符串
 * */
export function plusXing(str, frontLen, endLen, cha) {
  let name = str.substring(0, str.lastIndexOf('.') + 1)
  let suffix = str.substring(str.lastIndexOf('.') + 1, str.length)
  if (name.length > 5) {
    let xing = ''
    for (let i = 0; i < 3; i++) {
      xing += cha
    }
    return name.substring(0, frontLen) + xing + name.substring(frontLen, endLen) + '.' + suffix
  } else {
    return str
  }
}
export const signType = [
  { label: '签名', icon: 'sign-icon-kongjian', type: 0, isRequired: true },
  { label: '印章', icon: 'sign-icon-kongjian1', type: 1, isRequired: true },
  { label: '日期', icon: 'sign-icon-kongjian4', type: 2, isRequired: true },
  { label: '单行文本', icon: 'sign-icon-kongjian3', type: 3, isRequired: true },
  { label: '多行文本', icon: 'sign-icon-kongjian5', type: 4, isRequired: true },
  { label: '复选框', icon: 'sign-icon-kongjian2', type: 5, isRequired: true },
  { label: '附件', icon: 'sign-icon-enclosure icon-file', type: 6, isRequired: true }
]

export function hignline(text, key) {
  //高亮
  return text.replace(new RegExp('(' + key + ')', 'ig'), "<span class='text-orange'>$1</span>")
}
export function contains(text, key) {
  //正则搜索
  return new RegExp('(' + key + ')', 'ig').test(text)
}
/**
 * 将base64转换为Blob
 * @param dataUrl base64图片数据
 * @param filename 文件名称
 * @returns {File}
 */
export function dataURLtoBlob(dataUrl) {
  //将base64转换为Blob
  let arr = dataUrl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

// 返回上一页
export function goBack() {
  let { from } = this.$route.query

  if (from) {
    this.$router.push(from)
  } else {
    this.$router.go(-1)
  }
}

/**
 * 指定返回日期（例：一个月后的日期）
 * @param day 待返回的范围 单位天 （例：30, -7）
 * @param format 返回日期的格式
 * @returns {*}
 */
export function assignDate(day, format) {
  const now = new Date()
  now.setDate(now.getDate() + day)
  return formDate(now, format)
}
/**
 * 指定返回浏览器类型
 */
export function BrowserType() {
  var userAgent = navigator.userAgent //取得浏览器的userAgent字符串
  var isOpera = userAgent.indexOf('Opera') > -1 //判断是否Opera浏览器
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera //判断是否IE浏览器
  var isEdge = userAgent.indexOf('Windows NT 6.1; Trident/7.0;') > -1 && !isIE //判断是否IE的Edge浏览器
  var isFF = userAgent.indexOf('Firefox') > -1 //判断是否Firefox浏览器
  var isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') == -1 //判断是否Safari浏览器
  var isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1 //判断Chrome浏览器
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    var fIEVersion = parseFloat(RegExp['$1'])
    return { name: 'IE', num: fIEVersion }
  } //isIE end

  if (isFF) {
    return { name: 'FF', num: 'FF' }
  }
  if (isOpera) {
    return { name: 'Opera', num: 'Opera' }
  }
  if (isSafari) {
    return { name: 'Safari', num: 'Safari' }
  }
  if (isChrome) {
    return { name: 'Chrome', num: 'Chrome' }
  }
  if (isEdge) {
    return { name: 'Edge', num: 'Edge' }
  }
  if (isIE11) {
    return { name: 'IE', num: 'IE' }
  }
  return { name: 'Chrome', num: 'Chrome' }
}

export const setCookie = function(name, value, days) {
  if (!days) days = 30
  var exp = new Date()
  exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
}

export const getCookie = function(name) {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) {
    return unescape(arr[2])
  }
  return ''
}
export const delCookie = function(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = this.getCookie(name)
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
}
/**
 * 数据去重
 * @param {} arr1
 * @param {*} arr2
 * @param {*} key
 */
export const array_diff = function(arr1, arr2, key) {
  const _arr = []
  for (let i = 0; i < arr1.length; i++) {
    _arr.push(arr1[i])
  }
  for (let i = 0; i < arr2.length; i++) {
    let flag = true
    for (let j = 0; j < arr1.length; j++) {
      if (arr2[i] === arr1[j]) {
        flag = false
        break
      }
    }
    if (flag) {
      _arr.push(arr2[i])
    }
  }
  return _arr
}

/**
 * 检测类型
 * @param ext 指定类型的数据
 * @return {function(...[*]=)}
 */
export function checkRealExt(ext) {
  return function(buffer) {
    for (let i = 0, length = ext.length; i < length; i++) {
      if (ext[i] !== buffer[i]) return false
    }

    return true
  }
}

/**
 * png类型检测
 * @param buffer
 * @return {boolean}
 */
export function pngExt(buffer) {
  if (checkRealExt([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a])(buffer)) {
    const startIndex = 33
    const firstImageDataChunkIndex = buffer.findIndex(
      (el, i) =>
        i >= startIndex &&
        buffer[i] === 0x49 &&
        buffer[i + 1] === 0x44 &&
        buffer[i + 2] === 0x41 &&
        buffer[i + 3] === 0x54
    )
    const sliced = buffer.subarray(startIndex, firstImageDataChunkIndex)

    if (
      !~sliced.findIndex(
        (el, i) => sliced[i] === 0x61 && sliced[i + 1] === 0x63 && sliced[i + 2] === 0x54 && sliced[i + 3] === 0x4c
      )
    ) {
      return true
    }
  }

  return false
}

/**
 * jpg类型检测
 * @param buffer
 * @return {*}
 */
export function jpgExt(buffer) {
  return checkRealExt([0xff, 0xd8, 0xff])(buffer)
}

/**
 * 账号加星号
 * @param account
 * @return {string|*}
 */
export function accountAsterisk(account) {
  if (isMobile(account)) {
    return account.substr(0, 3) + '****' + account.substr(7)
  } else if (isEmail(account)) {
    return account.substr(0, 1) + '****' + account.substr(account.lastIndexOf('@') - 1)
  }
  return account
}

/**
 * 判断是否是企业微信浏览器
 */
export const isWeChat = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) && ua.match(/wxwork/i)) {
    return true
  } else {
    return false
  }
}

// 微信授权
function wxconfig(config) {
  return new Promise((resolve, reject) => {
    window.wx.config(config)
    window.wx.ready(resolve)
    window.wx.error(reject)
  })
}
function agentConfig(config) {
  return new Promise((success, fail) => {
    window.wx.agentConfig({ ...config, success, fail })
  })
}

// 通讯录组件 + 企微环境 + 需要展示通讯录组件的页面
export async function usewxconfig(theurl = location.href.split('#')[0]) {
  // 通讯录组件 + 企微环境 + 需要展示通讯录组件的页面

  const signatureData = await homeAxios.getSignature({
    url: decodeURIComponent(theurl)
  })
  const { signature, nonceStr, timestamp, authAppid, agentId, agentSignature } = signatureData.data.config
  const corpId = signatureData.data.corpId
  const jsApiList = ['openDefaultBrowser']

  await wxconfig({
    beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
    debug: false,
    signature: signature,
    nonceStr: nonceStr,
    timestamp: timestamp,
    appId: authAppid,
    jsApiList
  })
  await agentConfig({
    corpid: corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
    agentid: agentId, // 必填，企业微信的应用id （e.g. 1000247）
    nonceStr: nonceStr,
    signature: agentSignature,
    timestamp: timestamp,
    appId: authAppid,
    jsApiList
  })
  window.WWOpenData.bindAll(document.querySelectorAll('ww-open-data'))
}
